export function isMobilePlatform(search = typeof window !== 'undefined' ? window.location.search : '') {
  const params = new URLSearchParams(search);
  const value = (
    params.get('platform') ||
    params.get('plateform') ||
    params.get('from') ||
    ''
  ).toLowerCase();
  return value === 'mobile' || value === 'app';
}
